import { useState } from "react";
import { Paper, Stack, Button, Divider, Box, Tooltip, } from "@mui/material";
import { Edit as EditIcon, } from '@mui/icons-material';
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import HistoryIcon from "@mui/icons-material/History";
import SendIcon from "@mui/icons-material/Send";
import { PermissionWrapper } from "../../../wrappers";
import { getGlobalCookie } from "../../../utils";
import AssignUserModal from "./AssignUserModal";
import StatusChangeModal from "./StatusChangeModal";
import TimelineModal from "./TimelineModal";
import ApproverModal from "./ApproverModal";
import ShopVisitCRU from "./ShopVisitCru";
import { useParams } from "react-router";
import { ShowAttachments } from "../../../shared_elements/components";
import StatusButton from "./StatusButton";
const ApprovalHeader = ({ shopVisit, isLoading, getShopVisit, handleItemClicked, handleUpload }) => {
    const params = useParams()
    const userInfo = JSON.parse(getGlobalCookie('lessorAccess'))
    const mergedUsers = [...shopVisit?.approver_users || []];
    const uniqueUsers = mergedUsers?.filter((user, index, self) => index === self.findIndex(u => u.id === user.id));
    const shopVisitStatus = shopVisit?.status?.value
    const checkUniqueUsers = uniqueUsers?.some(ele => ele.id === userInfo?.user?.id)
    const [modalData, setModalData] = useState({ approverModal: false, assignUserModal: false, statusModal: false, searchUser: "", editModal: false })
    const [timeLineData, setTimeLineData] = useState({ modal: false, data: [] })
    const [uploadfileList, setUploadfileList] = useState({ mode: '', modal: false, data: null });
    const [addEditShopVisit, setAddEditShopVisit] = useState({ mode: '', modal: false, data: null });
    const onSearchUserField = (event) => { setModalData({ ...modalData, searchUser: event.target.value }); };
    const onDeleteAttachments = (deltedslug) => {
        setUploadfileList({
            ...uploadfileList, data: {
                ...uploadfileList.data,
                attachments: uploadfileList.data.attachments.filter(item => item.slug !== deltedslug)
            }
        });
        if (addEditShopVisit?.modal) {
            setAddEditShopVisit({
                ...addEditShopVisit,
                data: {
                    ...addEditShopVisit.data,
                    attachments: addEditShopVisit.data.attachments.filter(item => item?.slug !== deltedslug)
                }
            })
        }
        getShopVisit();
    }
    return (
        <>
            <Stack direction="row" spacing={1} alignItems="center">
                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "shop_visit", operationType: ['U'] }}>
                    {shopVisit?.status?.value === 1 ? <Tooltip title="Edit">
                        <EditIcon fontSize="small" color="primary" onClick={() => { setModalData({ ...modalData, editModal: true }); handleItemClicked('EditIcon') }} sx={{ cursor: "pointer" }} />
                    </Tooltip> : null}
                </PermissionWrapper>
                {shopVisit?.approver_users?.length > 0 && <Button
                    variant="outlined"
                    size="small"
                    startIcon={<GroupOutlinedIcon />}
                    sx={{ textTransform: "none", cursor: "pointer" }}
                    onClick={() => { setModalData({ ...modalData, approverModal: true }); handleItemClicked('Approve/Reject Button') }}
                >
                    Users
                </Button>}
                {(shopVisit?.status?.value === 1 ||shopVisit?.approver_users?.length > 0) ?  <Divider orientation="vertical" flexItem /> :null }
               
                <Button
                    variant="outlined"
                    size="small"
                    startIcon={<HistoryIcon />}
                    sx={{ textTransform: "none" }}
                    onClick={() => { setTimeLineData({ modal: true }); handleItemClicked('RevisionHistoryIcon') }}
                >
                    Status Timeline
                </Button>
                <Divider orientation="vertical" flexItem />
                {shopVisit?.status && (
                    <StatusButton statusData={shopVisit?.status} />
                )}
            </Stack>
            <Stack direction="row" >
                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "shop_visit", operationType: ['APR_REJ'] }}>
                    {(uniqueUsers == null || (Array.isArray(uniqueUsers) && (uniqueUsers.length === 0 || checkUniqueUsers))
                    ) && (shopVisitStatus === 2 || shopVisitStatus === 7) ?
                        <Button
                            color="primary"
                            variant="outlined"
                            size="small"
                            onClick={() => { setModalData({ ...modalData, statusModal: true }); handleItemClicked('Approve/Reject Button') }}
                        >
                            Approve/Reject
                        </Button>
                        : null
                    }
                </PermissionWrapper>
                <Box style={{ display: 'flex', alignItems: "center", }}>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "shop_visit", operationType: ['U'] }}>
                        {shopVisit?.status && [1, 2, 5, 7].includes(shopVisitStatus) &&
                            (uniqueUsers == null || (Array.isArray(uniqueUsers) && (uniqueUsers.length === 0 || checkUniqueUsers))
                            ) ? (
                            <>
                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "shop_visit", operationType: ['APR_REJ'] }}>
                                    {(shopVisitStatus === 2 || shopVisitStatus === 7) ? <Box className="divider"></Box> : null}
                                </PermissionWrapper>
                                <Box >
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        size="small"
                                        onClick={() => { setModalData({ ...modalData, assignUserModal: true }); handleItemClicked((shopVisitStatus === 1 || shopVisitStatus === 2) ? "Send for Review Button" : "Send For Approval Button") }}
                                        startIcon={<SendIcon />}
                                        sx={{
                                            textTransform: "none",
                                            fontSize: { xs: "7px", md: '13px' }
                                        }}
                                    >
                                        {shopVisitStatus === 1 ? "Send for Review" : shopVisitStatus === 2 ? "Add Reviewer" : shopVisitStatus === 5 ? "Send For Approval" : "Add Approver"}
                                    </Button>
                                </Box>
                            </>
                        ) : null
                        }
                    </PermissionWrapper>
                </Box>
            </Stack>
            {
                modalData.editModal ?
                    <ShopVisitCRU
                        addEditShopVisit={{ data: shopVisit, modal: modalData?.editModal }}
                        modeType="edit"
                        // onOpenAttachments={() => setUploadfileList({ modal: true, data: addEditShopVisit?.data })}
                        getResponseBack={() => getShopVisit()}
                        onToggleModal={() => setModalData({ modal: false, mode: '', data: null })}
                        params={params}
                        fileUpload={handleUpload}
                        onOpenAttachments={() => setUploadfileList({ modal: true, data: shopVisit, mode: 'view' })}
                    /> : null
            }
            {
                uploadfileList.modal ? <ShowAttachments
                    moduleName="Shop Visit"
                    url='lease/shop-visit'
                    attachmentsData={uploadfileList}
                    getResponseBack={onDeleteAttachments}
                    toggleModalFn={() => setUploadfileList({ modal: false, data: null, mode: '' })}
                    onViewDisabled={uploadfileList?.mode === 'view'}
                    permissionKey='shop_visit'
                /> : null
            }
            {modalData?.assignUserModal ? <AssignUserModal params={params} modalData={modalData} onSearchUserField={onSearchUserField} pageTitle="ShopVisit" pageLoader={isLoading?.pageLoader} userData={shopVisit} getResponseBack={() => getShopVisit()} toggleModalFn={() => setModalData({ assignUserModal: false, searchUser: "" })} /> : null}
            {modalData?.statusModal ? <StatusChangeModal params={params} modalData={modalData} pageTitle="ShopVisit" pageLoader={isLoading?.pageLoader} shopVisit={shopVisit} getResponseBack={() => getShopVisit()} toggleModalFn={() => setModalData({ statusModal: false, searchUser: "" })} fileUpload={handleUpload} /> : null}
            {modalData?.approverModal ? <ApproverModal params={params} modalData={modalData} onSearchUserField={onSearchUserField} pageTitle="ShopVisit" pageLoader={isLoading?.pageLoader} approvalData={shopVisit?.approver_users} toggleModalFn={() => setModalData({ approverModal: false, searchUser: "" })} /> : null}
            {timeLineData?.modal ? <TimelineModal pageTitle="ShopVisit" slug={shopVisit?.slug} timeLineData={timeLineData} toggleModalFn={() => setTimeLineData({ modal: false })} /> : null}
        </>

    );
};

export default ApprovalHeader;